import { render, staticRenderFns } from "./attribute-tab.vue?vue&type=template&id=5db7ab8c"
import script from "./attribute-tab.vue?vue&type=script&lang=js"
export * from "./attribute-tab.vue?vue&type=script&lang=js"
import style0 from "./attribute-tab.vue?vue&type=style&index=0&id=5db7ab8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports